(() => {
  if (document.documentElement.dataset.psTypeAliasScript === 'true') return;
  const initialize = (root) => {
    root.querySelectorAll('[data-ps-facets-form]').forEach((form) => {
      const groups = new Map();
      form.querySelectorAll('[data-ps-type-alias]').forEach((label) => {
        const key = label.dataset.psTypeAlias;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(label);
      });
      groups.forEach((labels, key) => {
        const tokens = key.split('|');
        if (tokens.length !== 2 || labels.length !== 2) return;
        const controls = labels.map((label) => label.querySelector('input[type="checkbox"]'));
        if (controls.some((input) => !input || input.name !== 'filter.p.product_type')) return;
        const primaryIndex = controls.findIndex((input) => input.value === tokens[0]);
        const secondaryIndex = controls.findIndex((input) => input.value === tokens[1]);
        if (primaryIndex < 0 || secondaryIndex < 0 || primaryIndex === secondaryIndex) return;
        const primary = controls[primaryIndex];
        const secondary = controls[secondaryIndex];
        const primaryLabel = labels[primaryIndex];
        const secondaryLabel = labels[secondaryIndex];
        const count = primaryLabel.querySelector('[data-ps-type-count]');
        if (!count) return;
        const sync = () => { secondary.checked = primary.checked; };
        if (primaryLabel.dataset.psTypeAliasReady === 'true') { sync(); return; }
        const reset = () => { queueMicrotask(sync); };
        try {
          primary.addEventListener('change', sync);
          form.addEventListener('submit', sync);
          form.addEventListener('reset', reset);
        } catch (_) {
          primary.removeEventListener('change', sync);
          form.removeEventListener('submit', sync);
          form.removeEventListener('reset', reset);
          return;
        }
        const selected = primary.checked || secondary.checked;
        const disabled = primary.disabled && secondary.disabled && !selected;
        primary.defaultChecked = secondary.defaultChecked = selected;
        primary.checked = secondary.checked = selected;
        primary.disabled = secondary.disabled = disabled;
        count.hidden = true;
        count.style.display = 'none';
        secondaryLabel.hidden = true;
        secondaryLabel.style.display = 'none';
        primaryLabel.dataset.psTypeAliasReady = 'true';
      });
    });
  };
  initialize(document);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      requestAnimationFrame(() => {
        document.querySelectorAll('[data-ps-type-alias-ready="true"] input').forEach((input) => {
          input.checked = input.defaultChecked;
        });
        initialize(document);
      });
    } else {
      initialize(document);
    }
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.documentElement.dataset.psTypeAliasScript = 'true';
})();
